module.exports = __webpack_public_path__ + "static/media/handStrength1.3abdec7b.png";